import React, { useMemo, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Table } from "../../components/Table/Table";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import { toast } from "react-toastify";
import moment from "moment";
import { useLightningNotificationReportMutation } from "../redux/api/api";
import apiRequest from "../redux/api/apiRequest";
import { useLazyLightningDeviceTriggerQuery } from "../redux/api/api";


const LightningNotificationReport = () => {

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const location = useLocation();
    const deviceData = location?.state?.data;
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [lightningTriggerApi] = useLazyLightningDeviceTriggerQuery();
    const [triggerLoading, setTriggerLoading] = useState(false);
    const [date, setDate] = useState();
    const today = moment();
    const [max] = useState(today.clone().toDate());


    const [list, setList] = useState([]);

    const [getLightningReport, { isLoading }] =
        useLightningNotificationReportMutation();

    const formatDate = (value) => {
        setDate(value);

        const start = value?.start;
        const end = value?.end;

        if (start && end) {
            const FROM = moment(start).format("YYYY-MM-DD");
            const TO = moment(end).format("YYYY-MM-DD");

            if (FROM !== "Invalid date" && TO !== "Invalid date") {
                console.log(FROM, TO);
                setFrom(FROM);
                setTo(TO);
                setPage(1);

                getList(deviceData?.id, search, FROM, TO, 1);
            }
        }
    };

    const getList = async (deviceId, search = "", fromDate = "", toDate = "", pageNo = 1) => {
        const res = await apiRequest(getLightningReport, {
            device_id: deviceId,
            search: search,
            start_date: fromDate,
            end_date: toDate,
            page: pageNo
        });

        console.log("Notification API:", res)

        if (res?.status === "success") {
            const formattedData = res?.lightning_device_list?.map((item) => ({
                id: item.id,
                datetime: moment(item.created_at).local().format("YYYY-MM-DD hh:mm A"),
                event: item.event ?? "--",
                distance: item.distance ?? "--",
                intensity: item.intensity ?? "--",
                // location: item.device?.location_id || "N/A",
                dummy: "--"
            })) || [];
            setList(formattedData);
        }
    }

    const columns = useMemo(() => [
        {
            Header: "S.No",
            accessor: "sno",
            Cell: ({ row }) => {
                return <p>{(page - 1) * 10 + row.index + 1}</p>;
            }
        },

        {
            Header: "Date & Time",
            accessor: "datetime",
            Cell: ({ value }) => {
                return <p>{value}</p>;
            }
        },

        {
            Header: "Events",
            accessor: "event",
            Cell: ({ value }) => {
                return <p>{value}</p>;
            }
        },

        {
            Header: "Distance",
            accessor: "distance",
            Cell: ({ value }) => {
                return <p>{value}</p>;
            }
        },

        {
            Header: "Intensity",
            accessor: "intensity",
            Cell: ({ value }) => {
                return <p>{value}</p>;
            }
        },

        // {
        //     Header: "Device Location",
        //     accessor: "location",
        //     Cell: ({ value }) => {
        //         return <p>{value || "N/A"}</p>;
        //     }
        // },

        {
            Header: "Desc ",
            accessor: "dummy",
            Cell: ({ value }) => {
                return <p>{value}</p>;
            }
        }

    ], [page]);

    const refreshPage = () => {
        setSearch("");
        setPage(1);
    };

    const pagination = {
        total: list.length,
        per_page: 10,
        current_page: page,
        last_page: 1
    };

    const handleLightningTrigger = async () => {

        if (!deviceData?.device_code) {
            toast.error("Device code not found");
            return;
        }
        setTriggerLoading(true);
        const res = await apiRequest(
            lightningTriggerApi,
            deviceData?.device_code
        );
        console.log("Trigger Response:", res);
        setTriggerLoading(false);

        if (res?.status === "success") {
            toast.success(res?.message || "Lightning Triggered Successfully");
            getList(deviceData?.id, search, from, to, page);
        } else {
            toast.error(res?.message || "Lightning Trigger Failed");
        }
    };

    useEffect(() => {
        if (deviceData?.id) {
            getList(deviceData.id, search, from, to, page);
        }
    }, [deviceData, page]);



    return (
        <div className="dashRightView home_section">

            <div className="d-flex ac-jb">
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary">
                    Lightning Notification Report
                </h2>
                <button
                    className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn"
                    style={{ backgroundColor: "#ffc701" }}
                    onClick={handleLightningTrigger}
                    disabled={triggerLoading}
                >{triggerLoading ? "Triggering..." : "Manual Trigger"}
                </button>
            </div>

            <div className="mt-3 mb-3">
                <div className="row">

                    <div className="col-md-6 mt-2">
                        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary">
                            Device Name :{" "}
                            <span className="primary1">
                                {deviceData?.name || "--"}
                            </span>
                        </h2>
                    </div>

                    <div className="col-md-6 mt-2">
                        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary">
                            Device Code :{" "}
                            <span className="primary1">
                                {deviceData?.device_code || "--"}
                            </span>
                        </h2>
                    </div>

                    <div className="col-md-6 mt-2">
                        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary">
                            Report Count :{" "}
                            <span className="primary1">
                                {list.length}
                            </span>
                        </h2>
                    </div>

                    {/* <div className="col-md-6 mt-2">
                        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary">
                            Device Location :{" "}
                            <span className="primary1">
                                {deviceData?.location_id || "N/A"}
                            </span>
                        </h2>
                    </div> */}


                </div>

                <div className="d-flex ac-js mt-3 ">
                    <div className="d-flex ac-js mt-3 ">
                        <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary me-3">
                            Search
                        </h4>
                        <input
                            type="text"
                            className="input-pop ps-2"
                            placeholder="Search"
                            value={search}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSearch(value);
                                setPage(1);
                                getList(deviceData?.id, value, from, to, 1);
                            }}
                        />
                    </div>
                    <div className="d-flex ac-js mt-3 ms-5 ">
                        <div className="d-flex ac-jc gap-2">
                            <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  primary me-3">
                                Range
                            </p>
                            <DateRangePicker
                                format="dd/MM/yyyy"
                                value={date}
                                max={max}
                                onChange={(e) => {
                                    formatDate(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className="d-flex ac-js mt-3 ">
                        <button
                            className="btn btn-danger ms-5"
                            onClick={() => {
                                setSearch("");
                                setDate(null);
                                setFrom("");
                                setTo("");
                                setPage(1);
                                getList(deviceData?.id);
                            }}
                        >
                            Refresh
                        </button>
                    </div>

                </div>
            </div>

            <Table
                columns={columns}
                data={list}
                show={true}
                pagecount={pagination}
                setPageno={setPage}
                isLoading={isLoading}
            />

        </div>
    );
};

export default LightningNotificationReport;